import {
	ResponsiveContainer,
	XAxis,
	YAxis,
	Tooltip,
	LabelList,
	ScatterChart,
	Scatter,
	Label,
	ZAxis,
	ReferenceLine,
} from "recharts";
import { numberFormatter } from "../../utils";

const CategoryScatter = (props: any) => {
	const data = props.data;
	const refX = props.refX;
	const refY = props.refY;
	const selected = props.recommended;
	const viewBy = props.view;

	const highlight = props.highlight;
	const { selectedSupplierCount, viewFor } = props;

	const handleScatterClick = (data: any) => {
		if (viewBy === "Supplier" || viewBy === "L3") {
			if (data.category == selected) {
				props.handleClick(null);
			} else {
				props.handleClick(data.category);
			}
		}
	};

	const customTooltip = ({ active, payload }: any) => {
		if (active && payload && payload.length) {
			const data = payload[0].payload;

			const popupStyle = {
				width: "12vw",
				background: "white",
				border: "1px solid #ccc",
				boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
				borderRadius: "1vh",
				color: "black",
				padding: 0,
			};

			return (
				<div style={popupStyle}>
					{/* Header Row */}
					<div className="w-full flex justify-between h-[3vh] items-center bg-[#f0f4f8] py-[3vh] px-[1vh] textSmall">
						<div className="font-bold uppercase">
							{typeof viewBy === "string" ? viewBy : "Category"}:
						</div>
						<div
							className="font-bold ml-1"
							style={{ color: "#3f3f3f" }}
						>
							{data.category}
						</div>
					</div>
					{/* Data Rows */}
					<div className="h-fit p-[1vh] mt-[.5vh] mb-[.5vh]">
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label-small"
								style={{
									color: "#5a5a5a",
									fontWeight: "normal",
								}}
							>
								Gross Margin:{" "}
							</label>
							<label
								className="graph-label-small"
								style={{
									color: "#3f3f3f",
									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.grossMargin, 2)}%
							</label>
						</p>
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label-small"
								style={{
									color: "#5a5a5a",
									fontWeight: "normal",
								}}
							>
								5 Year CAGR:{" "}
							</label>
							<label
								className="graph-label-small"
								style={{
									color: "#3f3f3f",
									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.cagr, 2)}%
							</label>
						</p>
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label-small"
								style={{
									color: "#5a5a5a",
									fontWeight: "normal",
								}}
							>
								Spend:{" "}
							</label>
							<label
								className="graph-label-small"
								style={{
									color: "#3f3f3f",
									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.cost, 0, "$")}
							</label>
						</p>
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label-small"
								style={{
									color: "#5a5a5a",
									fontWeight: "normal",
								}}
							>
								Sales:{" "}
							</label>
							<label
								className="graph-label-small"
								style={{
									color: "#3f3f3f",
									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.revenue, 0, "$")}
							</label>
						</p>
					</div>
				</div>
			);
		}
		return null;
	};

	const fillColor = (type: string) => {
		if (type == "growthPotential") {
			return "#EAA61482";
		} else if (type == "lowPerformers") {
			return "#DA505582";
		} else if (type == "growCategory") {
			return "#86BC2582";
		} else {
			return "#62B5E582";
		}
	};
	const getInitials = (str: any) => {
		// Remove extra spaces and split by space
		const words = str.trim().split(/\s+/);
		if (words.length >= 2) {
			// Take first letter of first two words
			return words[0][0] + words[1][0];
		} else if (words.length === 1 && words[0].length >= 2) {
			// Take first two letters of the single word
			return words[0].substring(0, 2);
		} else if (words.length === 1) {
			// If only one letter in the word, return it
			return words[0];
		}
		return "";
	};

	const renderCustomizedLabel = (props: any, d: any) => {
		const { x, y, width, value, name } = props;
		return (
			<>
				{viewFor?.length === 0 && viewBy !== "District" && (
					<text
						x={x + width / 2}
						y={y - 10}
						fill="#000"
						fontSize={10}
						textAnchor="middle"
						dominantBaseline="middle"
					>
						{d.length > 10 ? d.slice(0, 10) + "..." : d}
					</text>
				)}
				{viewFor?.length !== 0 &&
					viewBy !== "District" &&
					viewFor?.includes(d) && (
						<text
							x={x + width / 2}
							y={y - 10}
							fill="#000"
							fontSize={10}
							textAnchor="middle"
							dominantBaseline="middle"
						>
							{d.length > 10 ? d.slice(0, 10) + "..." : d}
						</text>
					)}
				{viewFor?.length === 0 && viewBy === "District" && (
					<text
						x={x + width / 2}
						y={y + 10}
						fill="#000"
						fontSize={10}
						textAnchor="middle"
						dominantBaseline="middle"
					>
						{getInitials(d)}
					</text>
				)}
				{viewFor?.length !== 0 &&
					viewBy === "District" &&
					viewFor?.includes(d) && (
						<text
							x={x + width / 2}
							y={y + 10}
							fill="#000"
							fontSize={10}
							textAnchor="middle"
							dominantBaseline="middle"
						>
							{getInitials(d)}
						</text>
					)}
			</>
		);
	};

	return (
		<>
			<ResponsiveContainer
				id="capture-area"
				width="100%"
				height={
					props?.summaryView === undefined || props?.summaryView
						? "100%"
						: "100%"
				}
			>
				<ScatterChart
					margin={{
						top: 40,
						right: 50,
						bottom: 20,
						left: 20,
					}}
				>
					<XAxis
						className="graph-label"
						stroke="black"
						type="number"
						dataKey="cagr"
						name="5-year CAGR"
						unit="%"
						domain={([dataMin, dataMax]) => {
							const divFactor = dataMax > 100 ? 20 : 10;
							return [
								Math.floor(dataMin / divFactor) * divFactor,
								Math.ceil(dataMax / divFactor) * divFactor,
							];
						}}

						// If you want custom ticks, you can define xTicks as in your first code
						// ticks={xTicks}
					>
						<Label
							value="5-year CAGR"
							offset={0}
							position="bottom"
							style={{ fill: "#000" }}
						/>
					</XAxis>

					<YAxis
						className="graph-label "
						stroke="black"
						dataKey="grossMargin"
						name="Gross Margin"
						unit="%"
						domain={([dataMin, dataMax]) => {
							const divFactor = dataMax > 100 ? 20 : 10;
							return [
								Math.floor(dataMin / divFactor) * divFactor,
								Math.ceil(dataMax / divFactor) * divFactor,
							];
						}}

						// If you want custom ticks, you can define yTicks as in your first code
						// ticks={yTicks}
					>
						<Label
							value="Gross Margin (%)"
							angle={-90}
							position="insideLeft"
							style={{ fill: "#000", textAnchor: "middle" }}
						/>
					</YAxis>

					<ZAxis
						type="number"
						dataKey="cost"
						range={data.length <= 10 ? [100, 2000] : [50, 500]}
					></ZAxis>

					<ReferenceLine
						x={refX}
						label={{
							position: "top",
							fill: "#ce9178",
							value: numberFormatter(refX, 2) + "%",
							fontStyle: "italic",
						}}
						stroke="black"
						strokeDasharray="5 3"
						opacity={0.3}
					/>

					<ReferenceLine
						y={refY}
						label={{
							position: "right",
							fill: "#ce9178",
							value: numberFormatter(refY, 2) + "%",
							fontStyle: "italic",
						}}
						stroke="black"
						strokeDasharray="5 3"
						opacity={0.3}
					/>

					<Tooltip
						contentStyle={{
							color: "white",
							backgroundColor: "rgb(26, 25, 22)",
						}}
						cursor={{ strokeDasharray: "3 3" }}
						content={customTooltip}
					/>
					{data.map((d: any, index: number) => {
						if (
							d.cagr > 50 ||
							d.cagr < -50 ||
							d.grossMargin <= 0 ||
							d.grossMargin >= 50
						) {
							return null;
						}
						return (
							<>
								<Scatter
									key={index}
									data={[d]}
									fill={fillColor(d.type)}
									onClick={handleScatterClick}
									opacity={
										selected == null && !highlight
											? 1
											: selected == d.category ||
											  highlight == d.category
											? 1
											: 0.1
									}
								>
									{((selectedSupplierCount === 10 &&
										viewBy == "Supplier") ||
										viewBy === "District") && (
										<LabelList
											dataKey={d.category}
											content={(ele: any) =>
												renderCustomizedLabel(
													ele,
													d.category
												)
											}
										/>
									)}
								</Scatter>
								<div className="flex justify-between ">
									<span className="italic text-[#86bc25] text-[0.8vw]">
										{props.view == "Supplier" &&
											"*Note: The above chart shows only top 250 suppliers by spend"}
									</span>
								</div>
							</>
						);
					})}
				</ScatterChart>
			</ResponsiveContainer>

			<span className="italics text-[0.8vw] text-[#86bc25]">*Note: The above data is only for top 250 suppliers by spend </span>
		</>
	);
};

export default CategoryScatter;
